import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

import { subscriptionProductsCrudStateConfig } from "../../../consts";

const subscriptionProductsMetaInitialState = makeCrudBuilderInitialState(
  subscriptionProductsCrudStateConfig
);

export default subscriptionProductsMetaInitialState;
